import { UntypedFormControl, UntypedFormArray } from '@angular/forms';

export class DescriptionFormModel {
  shortDescription: UntypedFormControl;
  invoiceDescription: UntypedFormControl;
  longDescription: UntypedFormControl;
  extendedDescription: UntypedFormControl;
  applicationSummary: UntypedFormControl;
  associatedComments: UntypedFormArray;
  marketingDescription: UntypedFormArray;
  abbreviatedDescription: UntypedFormControl;
  labelDescription: UntypedFormControl;
  keySearchWords: UntypedFormControl;
  shippingRestrictions: UntypedFormControl;
  slangDescription: UntypedFormControl;
  unspscDescription: UntypedFormControl;
  vmrsDescription: UntypedFormControl;
}
